import { EmptyAppointmentQueryPropsFactory, IAppointmentProps, IAppointmentQueryProps } from '@/entities/Appointment'
import { EmptyResponsePropsFactory, IResponseProps } from '@/entities/Response'

export interface IAppointmentState {
  response: IResponseProps<IAppointmentProps>
  current: IAppointmentProps | null
  query: IAppointmentQueryProps
  type: string | null
  open: boolean
  scrollTop: number
}

export const state = (): IAppointmentState => ({
  response: EmptyResponsePropsFactory(),
  current: null,
  query: EmptyAppointmentQueryPropsFactory(),
  type: null,
  open: false,
  scrollTop: 0
})

export default state
